<template>
    <section class="steps">
        <div class="text">
            <h2>{{ config.BRIEF_STEPS_TITLE }}</h2>
            <p>{{ config.BRIEF_STEPS_DESCRIPTION }}</p>
        </div>
        <div class="steps">
            <div v-for="(step, index) in steps" :key="index" class="step">
                <component :is="step.image" :color="config.COLOR_PRIMARY"/>
                <h4>{{ step.description }}</h4>
            </div>
        </div>
        <!-- <div class="title">
            <h1>BRIEF</h1>
        </div> -->
    </section>
</template>
<script>
import { SolutionConsumer } from '@skeepers/platform-framework/mixins';
import {
    IconBrief1,
    IconBrief2,
    IconBrief3,
    IconBrief4,
} from '@skeepers/platform-framework/components/svg';

export default {
    name: 'BriefSteps',
    mixins: [SolutionConsumer],
    computed: {
        steps () {
            return [
                {
                    description: this.config.BRIEF_STEPS_TYPEFORM,
                    image: IconBrief1,
                }, {
                    description: this.config.BRIEF_STEPS_UPLOAD,
                    image: IconBrief2,
                }, {
                    description: this.config.BRIEF_STEPS_CONTACT,
                    image: IconBrief3,
                }, {
                    description: this.config.BRIEF_STEPS_AMBASSADOR,
                    image: IconBrief4,
                },
            ];
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@skeepers/platform-framework/assets/scss/mixins';
@import '~@skeepers/platform-framework/assets/scss/colors';

$step-width: 150px;

section {
    // position: relative;
    text-align: center;
    display: grid;
    gap: 60px;

    > .text {
        text-align: center;
    }

    > .steps {
        display: grid;
        gap: 60px;
        justify-content: center;
        grid-template-columns: repeat(auto-fit, $step-width);

        > .step {
            @include flex-vertical();
            align-items: center;

            > svg {
                @include square($step-width);
                margin-bottom: 40px;
                display: block;
                padding: 20px;
                border-radius: 8px;
                box-shadow: 6px 6px 12px 0 rgba($black, .1);
                background-color: $white;
                z-index: 1;
            }

            > h4 {
                font-weight: normal;
                margin: 0;
            }
        }
    }

    @include breakpoint-min(xs) {
        padding: 60px;
    }

    @include breakpoint-min(lg) {
        padding: 120px;
    }

    // > .title {
    //     position: absolute;
    //     right: 0;
    //     top: 0;
    //     bottom: 0;
    //     margin: -80px;
    //     writing-mode: vertical-rl;
    //     z-index: 0;

    //     > h1 {
    //         font-weight: 800;
    //         font-size: 160px;
    //         text-align: left;
    //         color: $white;
    //         user-select: none;
    //     }
    // }

}
</style>
